import s from "./ThreadNotice.module.scss"

type ThreadNoticeProps = {
  /** Already phrased for the reader, with handles resolved to names. */
  text: string
}

/**
 * No timestamp of its own: it sits between messages that are stamped, and a
 * stamp on every notice turns a group's admin history into small print.
 */
export function ThreadNotice({ text }: ThreadNoticeProps) {
  return <p className={s.notice}>{text}</p>
}
